var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("editor-settings")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$ct("grid-settings")))]),
                  _c("w-input-number", {
                    attrs: {
                      decimals: 0,
                      "min-value": 1,
                      label: _vm.$ct("cell-width"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.settings.GridSettings.CellWidth,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.GridSettings, "CellWidth", $$v)
                      },
                      expression: "settings.GridSettings.CellWidth",
                    },
                  }),
                  _c("w-input-number", {
                    staticClass: "mts",
                    attrs: {
                      decimals: 0,
                      "min-value": 1,
                      label: _vm.$ct("cell-height"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.settings.GridSettings.CellHeight,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.GridSettings, "CellHeight", $$v)
                      },
                      expression: "settings.GridSettings.CellHeight",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { staticClass: "mt", attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      fancy: "",
                      "has-error": !_vm.hasValidSaleId,
                      label: _vm.$ct("label-preview-id"),
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.checkHasValidComputedId()
                      },
                    },
                    model: {
                      value: _vm.settings.PreviewDocumentID,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "PreviewDocumentID", $$v)
                      },
                      expression: "settings.PreviewDocumentID",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("label-show-margin-ruler") },
                    model: {
                      value: _vm.settings.ShowMarginRuler,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "ShowMarginRuler", $$v)
                      },
                      expression: "settings.ShowMarginRuler",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _vm.isSupportSession
                    ? _c("w-checkbox", {
                        attrs: { label: _vm.$ct("only-editable-by-support") },
                        model: {
                          value: _vm.onlyEditableBySupport,
                          callback: function ($$v) {
                            _vm.onlyEditableBySupport = $$v
                          },
                          expression: "onlyEditableBySupport",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isValid, icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }